export default "__VITE_ASSET__8AvAArJ9__"